/*
 * @Descripttion:
 * @version:
 * @Author: geory
 * @Date: 2021-12-23 18:40:38
 * @LastEditors: geory
 * @LastEditTime: 2025-09-16 14:44:57
 */
import Vue from "vue";
import Vuex from "vuex";
import configs from "../config/config";

Vue.use(Vuex);

const state = {
  userInfo: null,
  loginDailogShow: false,
  token: null,
  huashuLineCountDialogShow: false,
  wenanShowLineCount: 3,
  settingInfo: {},
  db: null,
  lk: configs.ak.slice(0, -7) + "ZhuM123",
};
const getters = {};
const mutations = {
  resetUserState(state) {
    state.userInfo = null;
  },
  updateState(state, data) {
    state.userInfo = data;
  },
  modifySettingInfo(state, data) {
    state.settingInfo = data;
  },
  modifyLoginDailogShow(state, data) {
    state.loginDailogShow = data;
  },
  modifyHuashuLineCountDialogShow(state, data) {
    state.huashuLineCountDialogShow = data;
  },
  modifyWenanShowLineCount(state, data) {
    state.wenanShowLineCount = data;
  },
  modifyToken(state, data) {
    state.token = data;
  },
  modifyDb(state, data) {
    state.db = data;
  },
};
const actions = {
  //dispatch
};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
});
